import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import {
  insertUpdateCarPassessApplication_action,
  getCarPassessApplicationDetails_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/carPassessApplication_action/carPassessApplication_action";
import Modal from "react-modal";
import moment from "moment";
import $ from "jquery";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import VendorDetails from "../../vendorDetails";
//
class CarPassesApplication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      PowerConnectionList: [],
      Is_Agree: false,
      Remark: "",
      CGST: "",
      SGST: "",
      Is_AgreeErr: "",
      DeadlineDate: "",
      Is_Required: true,
      carPassessId: "",
      currentDate: moment().format("DD-MM-YYYY"),
      StatusID: "",
      Is_View: false,
      RoleID: sessionStorage.getItem("RoleIDSS"),
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
    };
    // this.getPowerConnectionList = this.getPowerConnectionList.bind(this)
    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.addCarPassessApplication()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      Is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });
    this.loadscript();
    this.getCarPassessDetails();
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleCancel() {
    window.history.back();
  }

  inputValidate() {
    const { Is_Agree } = this.state;

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({
        Is_AgreeErr: "kindly agree to disclaimer mentioned in this form for Car park passes",
      });
    }
  }

  getCarPassessDetails() {
    const { Remark, Is_Agree, isQuantity, Is_Required } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getCarPassessApplicationDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          this.setState({
            carPassessId: data.data[0]["CarPassesID"],
            isQuantity: data.data[0]["CarPassesQuantity"],
            Is_Required: data.data[0]["IsRequiredCarPasses"],
            Remark: data.data[0]["Remark"],
            Is_Agree: data.data[0]["IsAgree"],
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  addCarPassessApplication() {
    const { Remark, Is_Agree, isQuantity, Is_Required, carPassessId } = this.state;
    this.inputValidate();
    this.setState({ isLoading: true });
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (Is_Agree) {
      this.props
        .insertUpdateCarPassessApplication_action(
          isQuantity,
          Is_Required == 1 ? true : false,
          Remark,
          Is_Agree,
          carPassessId,
          ManualFormsID,
          ServiceID,
          VendorDetails
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess(
              this.state.StatusID == 0
                ? "Car Passes Form Submitted Successfully"
                : "Car Passes Form Updated Successfully"
            );
            setTimeout(() => {
              this.props.navigate("/manualForms");
            }, 2000);
            this.handleCancel();
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      toastError("Plase Enter mandatory feilds!");
      this.inputValidate();
      this.setState({ isLoading: false });
    }
  }

  render() {
    const {
      isLoading,
      Is_Agree,
      Remark,
      Is_AgreeErr,
      currentDate,
      DeadlineDate,
      Is_Required,
      StatusID,
      Is_View,
      RoleID,
      isHideSection, isOpenConfirmationModal
    } = this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));

    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div
          className={!isHideSection ? "with-dr-container" : ""}
          style={{ marginTop: RoleID == 1 ? "0px" : "" }}
        >
          <div className="">
            {!isHideSection && <div className="row">
              <ExhibitorTopMenu />
            </div>}
            <div className="exb-top-space">
              <div className="row">
                <div class="card rounded-0 border shadow-none">
                  <div class="card-header p-2" style={{ paddingleft: "7px !important" }}>
                    <h3 class="card-title" style={{ fontsize: "15px" }}>
                      Car Passes Application
                    </h3>
                  </div>
                  <div class="card-body p-1 m-2">
                    {!isHideSection &&
                      <ol className="text-left">
                        <li>Car pass is valid only for show days: <span className="fw-semibold">{moment(sessionStorage.getItem("ExhibitionFromDateSS"), 'DD-MMM-YYYY').format('DD.MM.YYYY')} to {moment(sessionStorage.getItem("ExhibitionToDateSS"), 'DD-MMM-YYYY').format('DD.MM.YYYY')}.</span></li>

                        <li>During <span className="fw-semibold">setup days</span>, parking will be available at <span className="fw-semibold">NASA Ground</span> only — <span className="fw-semibold">not inside the venue</span>.</li>

                        <li><span className="fw-semibold">Parking is on a first-come, first-served basis</span>.</li>

                        <li>If the venue parking is full, exhibitors must park their vehicles at <span className="fw-semibold">NASA Ground</span>.</li>

                        <li><span className="fw-semibold">India ITME Society</span> or the <span className="fw-semibold">venue management</span> shall <span className="fw-semibold">not be responsible for any damage</span> to vehicles or belongings parked either at the <span className="fw-semibold">Exhibition Venue</span> or <span className="fw-semibold">NASA Ground</span>.</li>
                      </ol>
                    }
                    <VendorDetails />
                    {!isHideSection && <div className="row mt-4">
                      <h6 className="mt-2 ">
                        Car pass Application{" "}
                        <span className="text-danger">
                          {" "}
                          Last Date Of Submission -{" "}
                          {this.props.location?.state?.ActualDeadline
                            ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                            : "-"}
                        </span>
                      </h6>
                    </div>}
                    <div class="table-responsive">
                      <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1 w-50">
                        <thead>
                          <tr>
                            <th colSpan={2}>
                              <strong>
                                <p>
                                  Dear{" "}
                                  {JSON.parse(sessionStorage.getItem("loginDataSS"))["CompanyName"]}
                                </p>

                                <p>
                                  As per your booth space 2 car Pass/passes are allotted to you.
                                </p>

                                <p>
                                  {" "}
                                  Kindly confirm the requirement of your allotted car pass by
                                  selecting Required / Not Required option from below.
                                </p>
                              </strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <label className="d-flex">
                                <input
                                  type="radio"
                                  name="Billing"
                                  checked={Is_Required == 1}
                                  disabled={Is_View || isDeadlinePassed}
                                  onChange={(e) => this.setState({ Is_Required: 1 })}
                                />
                                <strong>Required</strong>{" "}
                              </label>
                            </td>
                            <td>
                              <label className="d-flex">
                                <input
                                  type="radio"
                                  checked={Is_Required == 0}
                                  disabled={Is_View || isDeadlinePassed}
                                  onChange={(e) => this.setState({ Is_Required: 0 })}
                                  name="Billing"
                                />
                                <strong>Not Required</strong>{" "}
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="row m-1">
                  <form>
                    <strong>
                      {" "}
                      <label>Remark</label>
                    </strong>
                    <textarea
                      class="form-control"
                      value={Remark}
                      onChange={(e) => this.setState({ Remark: e.target.value })}
                      maxLength={300}
                      disabled={Is_View || isDeadlinePassed}
                      rows="3"
                    ></textarea>
                    <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                      <input
                        type="checkbox"
                        checked={Is_Agree}
                        disabled={Is_View || isDeadlinePassed}
                        onChange={(e) =>
                          this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })
                        }
                      />
                      <strong>
                        I confirm the above requirements and disclaimer
                        <span className="required">*</span>.
                      </strong>
                    </label>
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {Is_AgreeErr}
                      </span>
                    }
                  </form>
                </div>
              </div>
              {!isHideSection && <div className="row">
                {currentDate > DeadlineDate && (
                  <span className="text-danger">THE DEADLINE TO FILL OUT THE FORM HAS PASSED.</span>
                )}
              </div>}
              {!isHideSection && <div className="d-flex justify-content-end mt-0">
                <button
                  type="button"
                  className="btn btn-aqua rounded-1 d-block"
                  style={{ marginRight: 10 }}
                  disabled={currentDate > DeadlineDate}
                  // onClick={() => this.addCarPassessApplication()}
                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                >
                  {this.state.StatusID == 0 ? "Submit" : "Update"}
                </button>
                <button
                  className="btn btn-gray rounded-1 d-block"
                  onClick={() => this.handleCancel()}
                >
                  Back
                </button>
              </div>}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    insertUpdateCarPassessApplication_action,
    getCarPassessApplicationDetails_action,
  })(CarPassesApplication)
);
